import { getCategory } from './../services/services'
import { type Getter, type Setter } from 'jotai'
import { allCategoriesAtom } from '../state/state'
import { type Category } from 'Types/beFiltersApi'

export const getAllCategories = async (
  get: Getter,
  set: Setter,
  ids: number[],
): Promise<Category[]> => {
  // filter out 0 because it's used as if it meant null by the BE services
  const filteredIds = ids.filter((id) => id !== 0)
  const uniqueIds = [...new Set(filteredIds)]
  // use allCategoriesAtom as cache
  const prevCategories = get(allCategoriesAtom)
  const newIds = uniqueIds.filter(
    (id) => !prevCategories.some((c) => c.Id === id),
  )
  if (newIds.length > 0) {
    // we have some cache misses, call the service(s) and add the new data to the cache
    const results = await Promise.all(newIds.map(getCategory))
    const allCategories = [...prevCategories, ...results]
    set(allCategoriesAtom, allCategories)
    return allCategories
  } else {
    await Promise.resolve()
    return prevCategories
  }
}
